<template>
  <page-content title="Atur Akses" :back-button="true" :with-margin="false">
    <template v-if="!pageLoading">
      <simple-list label="Nama Lengkap" :text="patient.fullname" />
      <simple-list label="Departemen" :text="patient.department?.name" />
      <simple-list label="E-mail" :text="patient.email" />
      <div class="mx-3 mt-3 d-flex gap-2">
        <div class="flex-grow-1">
          <h4>Roles</h4>
          <small> {{ plural(selectedRoles.length, "role") }} selected </small>
          <div class="roles-wrap px-3 mt-1">
            <ul>
              <li v-for="role in roles" :key="role.id">
                <label class="d-flex">
                  <input
                    type="checkbox"
                    :value="role.name"
                    v-model="selectedRoles"
                  />
                  <span class="ml-2">
                    {{ capitalize(role.name) }}
                  </span>
                </label>
                <ul v-if="role.permissions.length > 0">
                  <li
                    v-for="permission in role.permissions"
                    :key="permission.id"
                  >
                    {{ permission.name }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="flex-grow-1">
          <h4>Direct Permissions</h4>
          <small>
            {{ plural(selectedPermissions.length, "permission") }} selected
          </small>
          <div class="roles-wrap px-3 mt-1">
            <ul>
              <li v-for="permission in permissions" :key="permission.id">
                <label class="d-flex">
                  <input
                    type="checkbox"
                    :value="permission.name"
                    v-model="selectedPermissions"
                  />
                  <span class="ml-2">
                    {{ permission.name }}
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mx-3 mt-2">
        <button-loading
          class="btn btn-block btn-success"
          @click="doSubmit()"
          :loading="saveLoading"
          :loading-color="colorSuccess"
        >
          Simpan
        </button-loading>
      </div>
    </template>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "change-user-access",
  data: function () {
    return {
      selectedRoles: [],
      selectedPermissions: [],
      saveLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      pageLoading: "pageLoading",
      patient: "currentUser",
      roles: "role/roles",
      permissions: "permission/permissions",
    }),
  },
  methods: {
    doSubmit: function () {
      this.saveLoading = true;
      axios({
        method: "POST",
        url: this.$store.getters.baseUrl + "user-access/" + this.patient.id,
        data: {
          roles: this.selectedRoles,
          permissions: this.selectedPermissions,
        },
      })
        .then(() => {
          this.saveLoading = false;
          this.$toasted.success("Berhasil disimpan.");
        })
        .catch(() => {
          this.saveLoading = false;
          this.$toasted.error("Tidak dapat menyimpan.");
        });
    },
  },
  created: function () {
    const id = this.$route.params.id;
    this.$store.dispatch("startPageLoading");
    this.$store.dispatch("role/getAll", {
      params: {
        includes: ["permissions:id,name"],
      },
    });
    this.$store.dispatch("permission/getAll");
    this.$store
      .dispatch("getUser", id)
      .then((response) => {
        const { roles, permissions } = response.data.data;

        roles.forEach((role) => this.selectedRoles.push(role.name));
        permissions.forEach((permission) =>
          this.selectedPermissions.push(permission.name)
        );

        this.$store.dispatch("stopPageLoading");
      })
      .catch(() => {
        this.$store.dispatch("stopPageLoading");
        this.$toasted.error("Gagal! Data tidak ditemukan.");
      });
  },
};
</script>

<style lang="sass" scoped>
.roles-wrap,
.permissions-wrap
  background: #efefef
  max-height: 250px
  overflow-y: auto
  list-style: none
  border-radius: 4px
  border-top: 10px solid #efefef
  border-bottom: 10px solid #efefef
  > ul
    list-style: none
    li
      line-height: 15px
      padding: 5px 0
    ul
      padding-left: 38px
</style>
